import {
  ADD_CALL_LIST,
  CHANGE_TASKS_VIEW,
  REMOVE_CALL_LIST,
  TOGGLE_ALERT,
  UPDATE_CALL_LIST,
  UPDATE_PREVIEW_DATA
} from '../actions/ui';

export default (state, action) => {
  state = state || {};

  switch (action.type) {
  case CHANGE_TASKS_VIEW:
    return { ...state, activeView: action.view };
  case ADD_CALL_LIST: {
    const callLists = { ...state.callLists };
    callLists[action.callList.id] = { ...action.callList };
    return { ...state, callLists: { ...callLists } };
  }
  case REMOVE_CALL_LIST: {
    const callLists = { ...state.callLists };
    delete callLists[action.callListId];
    return { ...state, callLists: callLists };
  }
  case TOGGLE_ALERT:
    return { ...state, alertMessage: action.message, error: action.error };
  case UPDATE_CALL_LIST: {
    const callLists = { ...state.callLists };
    callLists[action.callList.id] = { ...action.callList };

    return { ...state, callLists: callLists };
  }
  case UPDATE_PREVIEW_DATA:
    return {
      ...state,
      previewOverlayRecordId: action.personId,
      previewOverlayRecordType: action.personType,
      previewOverlayTaskId: action.taskId
    };
  default:
    return state;
  }
};
